var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.66797C22.6024 9.66797 26.3338 13.3986 26.334 18.001C26.334 22.6035 22.6025 26.335 18 26.335C13.3976 26.3348 9.66699 22.6034 9.66699 18.001C9.66717 13.3987 13.3978 9.66814 18 9.66797ZM18 11.335C14.3244 11.3351 11.3342 14.3254 11.334 18.001C11.334 21.6767 14.3243 24.6678 18 24.668C21.6758 24.668 24.667 21.6768 24.667 18.001C24.6668 14.3253 21.6757 11.335 18 11.335ZM18 13.001C18.46 13.001 18.834 13.375 18.834 13.835V17.333C18.8341 17.7911 19.0281 18.001 19.4863 18.001H22.167C22.627 18.001 23 18.375 23 18.835C22.9999 19.2948 22.6269 19.668 22.167 19.668H18.3242C17.4034 19.668 17.167 19.2255 17.167 18.3047V13.835C17.167 13.3751 17.5401 13.0011 18 13.001Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobType);
export default __webpack_public_path__ + "static/media/job-type.d61ef1c51daf9174fc64c3d5474ecf4e.svg";
export { ForwardRef as ReactComponent };